import React from "react";

/**
 * FlightSearchSkeleton
 * - shows left-side filter skeleton + right-side offers / filters / result list
 * - prop `results` controls how many dummy result cards to render
 */
export default function FlightSearchSkeleton() {
  return (
    <div className="bg-gray-50 min-h-screen animate-pulse" aria-hidden="true">
      <div className="max-w-[1400px] mx-auto p-6">
        <div className="flex gap-6">
          {/* LEFT SIDEBAR: filters */}
          <aside className="w-72 flex-shrink-0 space-y-6">
            {/* small header block */}
            <div className="h-12 bg-gray-100 rounded-md" />

            {/* first filter group */}
            <div className="bg-white p-4 rounded-xl border">
              <div className="h-5 bg-gray-100 rounded w-36 mb-3" />
              <ul className="space-y-3">
                {Array.from({ length: 4 }).map((_, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <div className="h-4 w-4 bg-gray-100 rounded" />
                    <div className="h-4 bg-gray-100 rounded w-44" />
                  </li>
                ))}
              </ul>
            </div>

            {/* second filter group */}
            <div className="bg-white p-4 rounded-xl border">
              <div className="h-5 bg-gray-100 rounded w-40 mb-3" />
              <ul className="space-y-3">
                {Array.from({ length: 4 }).map((_, i) => (
                  <li key={i} className="flex items-center gap-3">
                    <div className="h-4 w-4 bg-gray-100 rounded" />
                    <div className="h-4 bg-gray-100 rounded w-48" />
                  </li>
                ))}
              </ul>
            </div>

            {/* third group / large block */}
            <div className="h-24 bg-white rounded-xl border flex items-center justify-center">
              <div className="h-5 bg-gray-100 rounded w-40" />
            </div>
          </aside>

          {/* MAIN CONTENT */}
          <main className="flex-1 space-y-6">
            <div className="p-4 space-y-6 animate-pulse">
              {/* <div className="flex gap-4">
                        <div className="h-16 w-60 bg-gray-200 rounded-xl" />
                        <div className="h-16 w-60 bg-gray-200 rounded-xl" />
                        <div className="h-16 w-60 bg-gray-200 rounded-xl" />
                      </div> */}

              <div className="grid grid-cols-3 gap-4">
                <div className="h-16 bg-gray-200 rounded-xl" />
                <div className="h-16 bg-gray-200 rounded-xl" />
                <div className="h-16 bg-gray-200 rounded-xl" />
              </div>

              {[1, 2, 3, 4, 5].map((i) => (
                <div
                  key={i}
                  className="p-4 border rounded-xl space-y-3 bg-white shadow-sm"
                >
                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-4">
                      <div className="h-12 w-12 bg-gray-200 rounded-md" />
                      <div className="space-y-2">
                        <div className="h-4 w-40 bg-gray-200 rounded" />
                        <div className="h-3 w-20 bg-gray-200 rounded" />
                      </div>
                    </div>
                    <div className="h-4 w-28 bg-gray-200 rounded" />
                    <div className="h-10 w-20 bg-gray-200 rounded-lg" />
                  </div>

                  <div className="grid grid-cols-2 gap-3 mt-2">
                    <div className="h-3 w-24 bg-gray-200 rounded" />
                    <div className="h-3 w-32 bg-gray-200 rounded" />
                  </div>
                </div>
              ))}
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}
